import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { PropertyCard } from "@/components/PropertyCard";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Heart } from "lucide-react";

export default function Favorites() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    (async () => {
      const { data } = await api.get("/favorites");
      setItems(data.map((d) => ({ ...d, _favorited: true })));
    })();
  }, [user, loading, navigate]);

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <span className="text-xs tracking-[0.2em] uppercase text-[#11783A] font-medium">Favoris</span>
        <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight mt-2 mb-8">Mes biens sauvegardés</h1>

        {items.length === 0 ? (
          <div className="text-center py-20">
            <Heart className="w-12 h-12 mx-auto text-muted-foreground mb-4" strokeWidth={1.5} />
            <p className="text-muted-foreground">Vous n'avez pas encore de favoris.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((l, i) => (
              <PropertyCard
                key={l.id}
                listing={l}
                index={i}
                onUnfavorite={(id) => setItems((p) => p.filter((x) => x.id !== id))}
              />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
